import React from 'react';
import PropTypes from 'prop-types';
import {Grid, TextField} from "@mui/material";
import {greyishBlue50, greyishBlue500, greyishBlue600} from "../../assets/jss/main";

TextEmphasisBloc.propTypes = {
    title: PropTypes.string || PropTypes.element,
    leftPart: PropTypes.string || PropTypes.element,
    rightPart: PropTypes.string || PropTypes.element,
    placeholder: PropTypes.string || PropTypes.element
};

function TextEmphasisBloc({
                              title = null,
                              leftPart = null,
                              rightPart = null,
                              placeholder = "",
                              isBold = true,
                              floatLeft = false,
                              isEditable = false,
                              editLeftPart = null
}) {
    return (
        <Grid container direction={"column"}>
            {title && (
                <span style={{
                    fontWeight: 600,
                    fontSize: "12px",
                    color: greyishBlue500
                }}>{title}</span>
            )}
            <Grid
                container
                direction={"row"}
                style={{
                    backgroundColor: greyishBlue50,
                    padding: "16px",
                    borderRadius: "8px",
                    marginBottom: "16px",
                    justifyContent: rightPart ? "space-between" : (floatLeft ? "start" : "center")
                }}
                flexWrap={"nowrap"}
            >
                { isEditable && (
                    <TextField
                        value={leftPart}
                        onChange={(event) => {editLeftPart(event.target.value)}}
                        size={"small"}
                        variant="standard"
                        sx={{
                            fontSize: isBold ? "20px" : "14px",
                            fontWeight: isBold ? 600 : 400,
                            color: greyishBlue600,
                            width: "100%"
                        }}
                    />
                )}

                {!isEditable && ((leftPart && (
                    <span style={{
                            fontSize: isBold ? "20px" : "14px",
                            fontWeight: isBold ? 600 : 400,
                            color: greyishBlue600,
                            width: rightPart ? "fit-content" : "100%"
                        }}>
                        {leftPart}
                    </span>
                )) ?? (placeholder && (
                    <span style={{
                        fontSize: "14px",
                        fontWeight: 400,
                        color: greyishBlue600
                    }}>
                        {placeholder}
                    </span>
                )))
                }

                {rightPart && (
                    <span>{rightPart}</span>
                )}
            </Grid>
        </Grid>
    );
}

export default TextEmphasisBloc;